/* eslint-disable max-len */
export default {
  header: {
    navigation: {
      home: 'Home',
      distribution: '배포',
      distributionEvent: '배포 이벤트',
      twitter: 'Twitter',
      whitepapers: '백서',
      downloads: '다운로드',
      wallet: 'Wallet',
      explorer: '브라우저',
      ecosystem: '생태시스템',
      skyminer: '스카이 채굴기',
      hardware: 'Hardware',
      blog: '블로그',
      buy: '스카이코인 구매',
      telegram: 'Telegram',
      discord: 'Discord',
      getWallet: 'Skycoin 구매',
      jobs: '작업',
      ecosystem_overview: '개요',
      skywire: 'Skywire',
      skywallet: 'Skywallet',
      obelisk: 'Obelisk',
      fiber: 'Fiber',
      cx: 'CX',
      cxo: 'CXO',
      other: '기타',
      pressreleases: 'Press Releases',
      gallery: '사진',
      events: 'Events',
      explorerApi: '브라우저 API',
      hardwareStore: '하드웨어 스토어',
      merchandise: '상품 스토어',
      skywallethdk: 'Skywallet HDK',
      whitepaper: 'Whitepapers',
    },
  },
  footer: {
    bounty: '바운티 채널',
    getStarted: '시작하기',
    explore: '익스플로러',
    community: '커뮤니티',
    wallet: '지갑 얻기',
    buy: '스카이코인 구매',
    infographics: '인포그래픽스',
    whitepapers: '백서',
    blockchain: '블록체인 익스플로러',
    distribution: '배포',
    blog: '블로그',
    twitter: '트위터',
    reddit: '래딧',
    github: 'Github',
    telegram: '텔레그램',
    slack: '슬랙',
    roadmap: '로드맵',
    skyMessenger: '스카이-메신저',
    cxPlayground: 'CX 플랫폼',
    team: '팀',
    subscribe: '구독 리스트',
    market: '마켓',
    jobs: 'Jobs',
    bitcoinTalk: '비트코인토크 ANN',
    instagram: '인스타그램',
    facebook: '페이스북',
    discord: 'Discord',
    youtube: 'Youtube',
  },
  buyBanner: {
    lead: '현재 스카이코인은 다음의 거래소에서 개별적으로 매매할 수 있습니다.',
  },
  buy: {
    heading: '스카이코인을 구매하기 위해 마음에 드는 거래소를 고르세요.',
    c2cx: 'C2CX에서 구매',
    cryptopia: '크립토피아에서 구매',
    distributionEvent: '배포 이벤트',
  },
  notFound: {
    404: '404',
    message: 'Whoops! Looks like you\'re lost! This page does not exist anymore or has been moved to a new URL',
    title: '페이지를 찾을 수 없습니다.',
    heading: '페이지를 찾을 수 없습니다.',
    home: '스카이코인 홈페이지',
  },
  architectureOverview: {
    title: 'Architecture overview',
    description: 'Architecture overview - components which make up the Skycoin ecosystem',
    heading: '아키텍처 개요',
  },
  getStarted: {
    heading: '스카이코인을 가지세요.',
    paragraph: '<p>True decentralization means no government can censor Skywire, no corporate interest can stop it.</p><p>The internet began as a community of people wanting to share information — the time has come to bring back that vision of the internet using a cryptocurrency that truly fulfills Satoshi’s vision of a decentralized cryptocurrency with Skycoin.</p>',
    buy: '스카이코인 구매',
    wallet: '지갑 얻기',
  },
  newsletter: {
    heading: '회원가입 및 업데이트 받기',
    button: '회원가입',
    input: '메일 주소를 입력해주세요',
    skyminerOption: 'I\'m Interested in a Skywire Miner',
  },
  markets: {
    title: 'Buy Skycoin',
    loading: 'Loading, please wait...',
    description: 'List of Skycoin markets',
    disclaimer: 'Please note that sending funds to crypto wolf before hitting "Start Transaction" will lead to transaction failure. Moreover, sending a different amount from the one indicated will also lead to transaction failure. Make sure that you have calculated the miner\'s fee in order to send the exact amount indicated',
    data: '시장 데이터',
    contact: '스카이코인을 상장시키기 원하는 당신의 거래소를 써서 이메일로 보내세요.',
    video: 'How To Buy Skycoin Direct From Skycoin.com',
  },
  home: {
    title: '스카이코인 - 제 3세대 암호화폐',
    description: '스카이코인은 사토시의 원래 비전을 발전, 비트코인의 문제점을 개선하였습니다.',
    banner: {
      heading: 'Skycoin 하드웨어 디스플레이',
      button: '사진보기',
    },
    bannerStore: {
      heading: '오늘 바로 스카이 채굴기를 하나 주문하세요!',
      button: 'Visit store',
    },
    hero: {
      heading: '스카이 코인이란?',
      paragraph: 'Skycoin 플랫폼은 세계적으로 가장 선진적인 블록체인 어플리케이션의 생태시스템입니다. Skycoin은 비트코인과 이더리움의 초기 공헌자들이 공동으로 개발한 것으로, 절대적으로 안전하고 무한 확장 가능하며 ISP과는 독립된 플랫폼입니다. Skycoin은 대역폭, 스토리지 및 해시레이트를 방패막으로 하여 사토시(Satoshi)의 가장 초기 전망을 구현하는 것을 목적으로 개발 되었습니다.',
      slider: {
        revolutionary: {
          title: '스카이 코인은 하나의 혁명입니다',
          description: '완전히 새로운 블록체인 생태계 정보.',
        },
        obelisk: {
          title: '스카이 코인은 Obelisk입니다',
          description: '하나의 새로운 커뮤니티 프로토콜은 PoS와 PoW중 코어 효율의 저하 문제를 해결했습니다.',
        },
        cx: {
          title: '스카이 코인은 CX입니다',
          description: '블록체인 개발에 초점을 둔 새롭고 강한 튜링 완성형 언어.',
        },
        skywire: {
          title: '스카이 코인은 Skywire입니다',
          description: '더 강해지고 더 빨라지고 더 안전해진 네트워크, 네트워크 프로토콜 및 대역폭 라우팅 알고리즘.',
        },
        fiber: {
          title: '스카이 코인은 Fiber입니다',
          description: '무한 확장 가능하고 완벽하게 맞춤 제작된 플랫폼은 Visa와 유사한 속도 및 보안성을 갖추었습니다.',
        },
      },
      buy: '스카이 코인사다',
      community: '커뮤니티',
      whitepapers: '백서',
      wallet: {
        get: '월렛 다운로드',
        blurb: '스카이코인은 새로운 인터넷 혁명을 이끌어갑니다.',
      },
    },
    nav: {
      architecture: '아키텍쳐 개론',
      whitepapers: '스카이코인 합의 백서',
      blockchain: '스카이코인 블록체인',
      cx: 'CX',
      cxo: 'CXO',
      skywire: 'Skywire',
      viscript: 'Viscript',
      cryptoSphere: 'CryptoSphere VPN',
      messenger: '스카이-메신저',
      mobileWallet: '모바일 지갑',
      bbs: 'BBS(블로그)',
    },
    distributionEvent: {
      heading: '배포 이벤트',
      body: '스카이코인 배포 이벤트가 시작되었습니다. 1%(1백만)의 스카이코인이 0.002 BTC / SKY 가격으로 판매될 것입니다.',
      participate: '참여',
    },
    blog: {
      heading: '블로그 최신 뉴스',
    },
    aboutSkywire: {
      heading: '스카이와이어는 무엇인가?',
      lead: 'Skywire is the new internet. An incentivized mesh network poised to become the privacy protocol of the future.',
      paragraph: 'Skywire’s goal is to make corporate internet service providers a thing of the past by giving the internet back to the people with its revolutionary privacy protocol. Peer-to-peer technology with a grassroots ethos, Skywire’s new networking protocol promotes net neutrality and sharing without blocking, slowdowns or censorship.',
      button: 'Read More about Skywire, Powered by Skycoin',
    },
    technology: {
      header: 'Skycoin Technology and Ecosystem:',
    },
    about: {
      heading: '스카이코인은 무엇인가?',
      lead: 'A currency for digital bandwidth, backed by the new internet. Fast transactions, no transaction fees, Skycoin is a third-generation cryptocurrency supporting a new free and open internet.',
      paragraph: 'Skycoin is the cryptocurrency of Skywire. That means Skycoin has a practical application more than simply acting as another digital currency. The way Skycoin works is this: When you pass something along the Skywire network, you earn Skycoin. When you need to access the bandwidth yourself, pay via Skycoin. It only takes seconds to send and receive, with thousands of transactions per second.',
      obelisk: 'OBELISK에 관한 더 많은 정보 얻기',
      speed: {
        heading: '속도',
        body: '우리가 개발한 스카이코인을 알리페이/애플 페이 서비스와 같은 신용카드와 비교해보겠습니다. 트랜잭션이 분 단위가 아닌 초단위로 생성됩니다.',
      },
      privacy: {
        heading: '개인정보보호',
        body: '스카이코인은 CoinJoin 프로토콜을 사용하여 다양한 지갑을 결합하여 거래를 성사시킴으로써 거래를 추적할 수 없습니다.',
      },
      security: {
        heading: '보안',
        body: '스카이코인은 채굴자 의도에 따라 움직이지 않기 때문에 51% 공격을 할 수 없고, 보다 안전합니다.',
      },
      ecosystem: {
        heading: '생태계',
        body: '우리는 실제로 스카이코인을 기반으로 한 메시징, 소셜 미디어, VPN 서비스 등의 어플리케이션 생태계를 구축하였습니다.',
      },
    },
    network: {
      label: '더 보기',
      heading: 'Obelisk',
      subheading: 'Skycoin합의 알고리즘',
      body: 'Skycoin에서 저희는 사용자들의 수요를 만족시킬수 있기를 바랍니다. 즉 하나의 중앙집권이 진정으로 존재하지 않은 탈중앙화 네트워크를 만들어가려는 것입니다. 이 미션을 완성하기 위해 저희는 PoW와 PoS를 뛰어넘어 전반적으로 새로운 탈중앙화 알고리즘을 생성하였고 블록체인의 내부 실행을 다시 구축하였습니다. 저희의 분산형 합의 알고리즘인 Obelisk는 성공적으로 이러한 네트워크를 제공해드렸습니다.<br/><br/>네트워크 신뢰형 합의 알고리즘은 집권의 발전을 저애합니다. Skycoin은 채굴할 필요가 없으며 51%의 공격을 방어할 뿐만아니라 몇분내에 거래를 진행할 수 있습니다. 모든 결정은 소수의 이익 연관자의 바람에 의한 것이 아닌 커뮤니티의 커뮤니케이션을 통해 실현된 것입니다.',
    },
    miner: {
      heading: '스카이 채굴기 탐색',
      subheading: 'Skycoin채굴기는 알심들여 디자인되고 배치되어 Skywire의 기반 시설에 탄탄한 전기통신 메인 네트워크를 제공해주었습니다. 맞춤 제작된 하드웨어는 소프트웨어 정의 네트워크에 최고급 안전 보장, 효율 및 성능을 제공해줄 것입니다. 멀티구조는 매개 노드가 Skywire상의 독립된 서비스를 전부 제공할 수 있도록 되어 있습니다. 노드를 격리시킴으로 하여 매 하나의 서비스가 외부 서비스의 공격을 받은 상황에서도 안전하게 실행될 수 있도록 하였습니다. 이렇게 서비스를 제공하는 노드는 OpenWRT 라우터가 관리하고 라우터는 엄격한 데이터 패키지의 리트윗 및 제어 규칙을 보유하고 있어 부가적인 보장을 제공해줍니다. Skywire 네트워크에 서비스와 안전 보장을 제공하는 스카이 채굴기는 보너스로 코인 시간을 획득하게 됩니다',
      link: 'Become a node | ko',
      more: '더많은 정보 얻기',
      headingHardware: 'Skycoin하드웨어 세트의 지속적인 실체화',
      morePhotos: '더 많은 사진 보기',
    },
    press: {
      heading: 'Skycoin Picked As Top 5 Crypto Projects For 2018',
      subheading: '2019년 가장 관심을 둘 만한 프로젝트',
      forbes: 'Skycoin aims to provide a “new internet” that is global, decentralized, and not controlled by any country, corporation, or government entity.  For privacy gurus or net neutrality enthusiasts, this is a project to stay on top of.',
      huffingtonPost: 'Net neutrality and consumer data privacy emerged as two key issues in tech in 2017. If you’re concerned about paying ridiculous fees to ISPs for unreliable coverage, having your data sold, or government monitoring and censorship - Skycoin provides hope. These are the core issues Skycoin is attempting to solve.',
    },
    ecosystem: {
      heading: 'Skycoin은 세계적으로 가장 선진적인 블록체인 어플리케이션 플랫폼입니다',
      subheading: 'Skycoin생태시스템',
      fiber: {
        title: 'Fiber',
        text: 'Skycoin플랫폼의 무한 확장 가능하고 고도로 맞춤 제작가능한 P2P 체인 시스템 구조입니다.',
      },
      obelisk: {
        title: 'Obelisk',
        text: '“신뢰성 웹”은 PoW & PoS의 기본 허점을 해결한 신형의 합의 알고리즘입니다.',
      },
      skycoin: {
        title: 'Skycoin',
        text: '가장 강력하고 완전한 암호 화페 플랫폼.',
      },
      coinHours: {
        title: '코인 시간',
        text: '보유하는 Skycoin을 통하여 획득 가능한 코인 시간은 Skycoin 플랫폼의 서비스 결제 메커니즘입니다.',
      },
      coinJoin: {
        title: '코인 조인',
        text: '네이티브 플랫폼은 코인 조인이 프라이버시를 완벽하게 지켜주고 추적 불가한 거래를 제공할 수 있도록 지원합니다.',
      },
      skyledger: {
        title: 'Skyledger',
        text: 'Platform for launching your very own ICO on top of Fiber, our blockchain technology.',
      },
      skywire: {
        title: 'Skywire',
        text: '하나의 무선 메쉬 네트워크인 신형 탈중앙화 네트워크를 통해 여러분들께 서비스를 제공해드립니다.',
      },
      skyminer: {
        title: '스카이 채굴기',
        text: '탄탄한 분산형 네트워크의 하드워크 핵심부분으로서 잠을 자는 순간에도 대역폭, 스토리지와 CPU 성능을 제공하여 이로부터 보수를 얻을 수 있습니다.',
      },
      nodes: {
        title: '노드',
        text: 'Skywire네트워크의 구성부분으로서 모든 사람들이 노드를 배치 가능하게 함으로써 Skywire 생태시스템의 탈중앙화를 보장하였습니다.',
      },
      cx: {
        title: 'CX',
        text: 'Golang 에 기반을 두어 맞춤 제작된 프로그래밍 언어로서 쉽게 배울 수 있고 편하게 조작할 수 있습니다.',
      },
      cxo: {
        title: 'CXO',
        text: 'Skywire 분산형 네트워크를 따라 디자인된 P2P 클라우드 스토리지 서비스입니다.',
      },
      kittyCash: {
        title: 'KittyCash',
        text: '현재 Fiber에서 건립된 가장 트렌디한 어플리케이션입니다. Kittycash는 키티를 원동력으로 한 완벽한 게임 생태시스템입니다.',
      },
      skyVpn: {
        title: 'SDN',
        text: 'Skywire네트워크에 내장된 엔드 투 엔드 가상 개인 암호화 기능으로서 프라이버시를 확실하게 보호합니다.',
      },
      skyMessenger: {
        title: 'Sky메신져',
        text: '저희의 완벽하게 암호화된 메신져는 도청이나 불법침입자를 막아드립니다.',
      },
      bbs: {
        title: 'BBS',
        text: '분산형 소셜 네트워크 서비스를 구축하는 프레임입니다.',
      },
    },
    news: {
      heading: '뉴스',
    },
    signup: {
      heading: '저희 Skyfleet 뉴스레터에 가입하여 저희와 함께 세계를 자유롭게 활보하세요!',
      body: '메일을 구독하여 Skycoin팀의 최근 추세, 정보 업데이트를 알아보세요. 여러분의 개인메일 주소만 입력하시면 바로 출발하실 수 있습니다.',
      button: '회원가입',
    },
    roadmap: {
      heading: '로드맵',
      blurb: 'GitHub에 방문하여 팔로우 또는 스카이코인의 개발 진행에 도움을 주세요. 우리는 오류 수정, 디자인 그리고 개발 관련 바운티 캠페인을 얼마 후에 개최할 예정입니다.',
      roadmapLink: '전체 로드맵을 보시기 바랍니다.',
      link: '우리의 로드맵을 보십시오. [pdf]',
      mobileLink: '스카이코인 로드맵 모바일 2017',
      community: '스카이코인의 최신 개발 동향을 알기 위해 스카이코인 텔레그램에 가입하세요.',
      communityLink: '커뮤니티에 가입하기',
      timeline: {
        network: {
          quarter: 'Q3',
          year: '2017',
          content: '첫번째 다운로드 가능한 네트워크 노드 출시, 사용자들은 네트워크 파워를 이용해 코인을 얻을 수 있습니다.',
        },
        applications: {
          quarter: 'Q3',
          year: '2017',
          content: '스카이와이어 네트워크의 첫번째 어플리케이션 출시 : 분산된, Redditesque, 소셜 미디어 플랫폼과 VPN 서비스',
        },
      },
    },
  },
  whitepapers: {
    title: '스카이코인 합의 백서',
    description: '백서 다운로드',
  },
  downloads: {
    title: '다운로드',
    description: '스카이코인 지갑 다운로드',
    wallet: {
      heading: 'SKYCOIN 월렛 다운로드',
      headingDaemon: 'Download Skywallet Daemon',
      lead: '단순 사용을 위해서는, 데스크탑 지갑을 다운로드하세요. 고급 사용, 또는 느린 속도의 경우, CLI 지갑이 귀하의 브라우저에서 직접 실행되며 UI를 제공합니다. ',
      build: '현재 버전 {version}.',
      macos: 'MacOS',
      linux: '리눅스',
      windows: '윈도우',
      android: 'Android',
      androidRecommended: 'Google Play Store',
      androidRecommendedComment: ' (recommended)',
      androidAdvanced: 'APK',
      androidAdvancedComment: ' (advanced)',
      iosRecommended: 'Apple iOS App Store',
      iosRecommendedComment: ' (recommended)',
      ios: 'iOS',
      withElectron: 'Installer',
      withElectronComment: ' (recommended)',
      withoutElectron: 'Portable',
      withoutElectronComment: ' (advanced)',
      download: '다운로드',
      instructions: 'Instructions',
      signature: '디지털 서명',
      torrent: '토렌트',
      linuxDaemon: 'Daemon',
      linuxDaemonComment: '  ',
      macsDaemon: 'Daemon',
      macsDaemonComment: '  ',
      windowsDaemon: 'Daemon',
      windowsDaemonComment: '  ',
    },
    whitepaper: {
      title: 'Whitepapers',
      description: 'Skycoin wallet Whitepapers.',
    },
    bbs: {
      heading: 'Skycoin BBS 다운로드',
      lead: 'Skycoin BBS는 Skycoin의 블록체인 기술인 Fiber을 사용하여 구축한 새세대 탈중앙화 커뮤니티 네트워크입니다.',
      githublink: 'Github에서 최신 이진법 문서 찾기',
      thinclient: 'BBS 씬 클라이언트를 향해',
    },
    whitepapers: {
      heading: 'Skycoin 커뮤니케이션 백서 다운로드',
      download: '다운로드',
      cryptocurrencyNetwork: '加密货币网络分布式共识算法白皮书',
      skyFramework: 'Sky: P2P 네트워크에서 커뮤니케이션을 구축한 동적 프레임 및 모델',
      skyHashConsensus: 'SkyHash: P2P 네트워크에 건립한 Hash 커뮤니케이션의 동적 모델',
      skyHash: 'SkyHash: Hash관점 동적 모델',
      sznajd2: 'Sznajd2: 커뮤니티 의식을 갖춘 관점 동적 모델 ',
      distributedAlgorithm: '암호화 화폐 네트워크의 분산형 합의 알고리즘',
    },
    assets: {
      heading: 'Skycoin브랜드 안내 다운로드',
      guidelines: 'Skycoin브랜드 안내',
      logo: 'Skycoin의 PNG 로고 파일',
      sch_logo: 'Coin Hours의 PNG 로고 파일',
      font: 'Skycoin의 Sans글꼴',
      branding: 'Skycoin v1.6.1',
    },
    skywire: {
      heading: 'Skywire',
      installationGuide: 'Skywire설치 안내 v1.0',
      minerAssemblyManual: 'Skywire채굴기 조립 안내 v2.3',
      minerAssemblyManualHiRes: 'Skywire채굴기 조립 안내 Hi-Res v2.3',
    },
    roadmap: {
      heading: '로드맵',
    },
  },
  thankYou: {
    message: 'Thank you! Your response has been recorded.',
  },
  infographics: {
    title: '인포그래픽스',
    description: 'Graphical overview',
  },
  distribution: {
    title: '스카이코인 배포 이벤트',
    description: '{date} 에, 1%(1백만)의 스카이코인이 0.002 BTC / SKY 가격으로 판매될 것입니다.',
    hero: {
      heading: '스카이코인 배포 이벤트',
      preEvent: '{begin} 에, 1%(1백만)의 스카이코인이 0.002 BTC / SKY 가격으로 판매될 것입니다. 이 배포이벤트는 {end} 또는 1%(1백만) 스카이코인이 판매될 경우 종료되며, 조기 종료될 수 있습니다.<br /><br />다음을 확인하세요.<a href="/distribution">skycoin.com/distribution</a> 이 이벤트에 참여하려면 <br /><br /><em>이 이벤트는 원래 2017년 7월 24일 예정되었으나, 현재 비트코인 네트워크의 불안정 때문에 2017년 8월 8일로 조정되었습니다.</em>',
      postEvent: '스카이코인 배포이벤트는 {date} 에 끝났습니다. 텔레그램의 스카이코인 커뮤니티에 침여하여 다가올 배포 이벤트를 확인하세요.',
      participate: '참가',
    },
    countdown: {
      preEvent: '배포이벤트는 <strong>{date}</strong> 12시에(GMT) 시작될 것입니다.',
      eventInProgress: '배포이벤트는 <strong>{date}</strong> 12시에(GMT) 끝날 것입니다.',
      days: '일',
      hours: '시간',
      minutes: '분',
      seconds: '초',
    },
  },
  roadmapPage: {
    heading: '개발 로드맵',
  },
  ecosystem: {
    title: '생태시스템',
    description: '생태시스템',
    heading: '생태시스템',
    subheading: '신형 인터넷 구조 ',
    skycoin: {
      heading: '구매 ',
      body: 'Skycoin는 비트코인과 이더리움의 문제점을 해결하기 위해 출시되었습니다. 그때까지만 해도 사토시 나카모토의 절대적인 탈중앙화 디지털 화페의 바람을 구현할 수 있는 다른 코인이 없었으므로, Skycoin이 출시된 것입니다.<br><br>Skycoin 고유의 Obelisk 합의 알고리즘을 통해, Skycoin 플랫폼에서는 중앙화 및 인위적인 조종이 필요 없습니다. Skycoin만의 특별한 프로그래밍 언어 CX는 수천 명의 개발자들이 블록체인속에 어플리케이션을 쉽게 배치할 수 있도록 합니다. Skycoin은 암호화 화폐로서 무료 거래 기능을 가지고 있고 또한 절대적인 프라이버시 기능이 곧 구현될 것이며 동시에 Visa 결제 처리 시스템과 유사한 속도를 지니고 있습니다. Skycoin의 가치는 투기가 아닌 내적 자산의 지원에 기초한 것입니다.<br><br>Skycoin에서 생성된 코인 시간을 보유하고 있을 경우, Skywire 네트워크에서 서비스를 구매하는 데 사용할 수 있고 더 많은 Skycoin을 환전할 수도 있습니다.',
      btn: 'CX의 더많은 정보 얻기 ',
    },
    skywire: {
      heading: 'Skywire',
      body: '신속함: 대형 ISP와는 달리 쓰로틀링과 기타 서비스 중단의 영향을 받지 않습니다.<br><br>프라이버시: 프라이버시는 여러분이 사이트를 방문할 때 추적 불가함을 의미합니다. Skywire 커뮤니티는 매달 거액의 비용을 지불하여 여러분을 추적하고 또 허가를 거치지 않은 상황에서 여러분의 사이트 방문 데이터를 판매하는 ISP와는 달리 인터넷 서비스를 통해 여러분의 프라이버시를 보호해 드립니다.<br><br>인센티브: Skywire는 무선 메쉬 네트워크 (WMN) 로 발전할 것입니다. 사용자가 Skycoin과 코인 시간을 동시에 벌 수 있음으로 하여 전체 네트워크에 대역폭 및 스토리지를 제공하는 하드웨어 노드를 실행할 수 있습니다. 사용자는 또한 획득한 코인 시간을 사용하여 원하는 콘텐츠 및 기타 네트워크 소스로 교환할 수 있습니다.<br><br>보안성: Skywire는 사용자가 자체로 생성하며 사용자들에게 서비스를 제공해드립니다. 사용자는 신뢰성 기반의 시스템이 운영하는 네트워크에서 결정을 하고 커뮤니티의 그룹 프로토콜을 통해 악성 노드를 메인 Skywire 네트워크로부터 중단시킵니다. 이러한 합의 모델은 Skywire가 공격이나 착취를 받거나 조종 당하지 않도록 보호해줍니다. <br><br>대기업들이 이익이라는 명분으로 소비자들을 줄곧 이용해 온 이러한 시대에 Skycoin의 Skywire 네트워크는 마치 때묻지 않은 순수한 영혼과도 같습니다. Skywire은 사람들에게 권리를 부여하는 동시에 더 강력하고, 더 빠르고, 더 안전한 인터넷을 만들어나갑니다.',
      skywireBtn: 'SKYWIRE의 더많은 정보 얻기 ',
      cxoBtn: 'CXO의 더 많은 정보 얻기',
    },
    obelisk: {
      heading: 'Obelisk',
      body: '독재 세계에서의 탈중앙화 <br/><br/>Obelisk는 작업증명(PoW)과 권익증명(PoS) 알고리즘의 허점으로부터 산생된 것입니다. Obelisk는 영원히 마이닝 풀에 의해 집중되거나 주주에 의해 조종될 수 없으며 이것은 Obelisk가 진정한 분산형임을 의미합니다. Obelisk는 신뢰성 웹 구조에 따라 네트워크에 미치는 영향을 분배합니다. 네트워크는 채굴기가 아닌 노드로 구성되고 각 노드마다 모두 자체의 블록체인을 보유하고 있으므로 모든 잠재된 불량행위를 방지하고 차단할 수 있습니다. 또한 비트코인이나 이더리움에 사용되는 고질적인 채굴기에 비해 노드의 생산, 획득 및 운영 원가가 훨씬 낮습니다. Obelisk는 신축성 있고 계산이 저렴하며 낭비가 없는 PoW 대체품으로 디자인 되었습니다. 이러한 특성은 알고리즘으로 하여금 지속 가능한 방식으로 저렴한 하드웨어에서 실행될 수 있도록 하는 반면 전력를 낭비하거나 보귀한 자연 자원을 낭비하지는 않습니다. 절대다수의 사람들이 모두 하나의 노드를 실행할 수 있을 때면 집중화는 거의 불가능한 상태가 될 것입니다. ',
      btn: 'Obelisk의 더 많은 정보 얻기 ',
    },
    skyledger: {
      heading: 'Skyledger',
      body: 'It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using \'Content here, content here\', making it look like readable English. Many desktop publishing packages and web page editors now use Lorem Ipsum as their default model text, and a search for \'lorem ipsum\' will uncover many web sites still in their infancy.',
    },
    experiments: {
      heading: 'Fiber',
      body: 'Fiber는 Skycoin 플랫폼의 무한 확장 가능하고 고도로 맞춤 제작할 수 있는 병행 동급 체인 구조입니다. Fiber은 블록체인보다 더 뛰어난 하나의 솔루션으로 분산형 원장 기술 문제들을 해결할 수 있습니다.<br><br>Fiber은 블록체인 3.0의 기반이 되어 마치 하나의 나란히 설치된 스트랜드와도 같은, 무한 신축가능한 블록체인 네트워크로 설명할 수 있습니다. Fiber의 모든 회사와 모든 프로젝트는 모두 완벽하게 맞춤화된 전용 사유 블록체인을 보유하고 있으며 그 속도 또한 Visa와 어깨를 견줄 수준입니다. 하여 개인 또는 회사 블록체인을 운영하는 기업들에게 블록체인 솔루션을 제공하여 기업이 자치를 구현하게 하고 자신의 체인을 완전히 제어할 수 있게 합니다. Fiber에 가입한 매개 체인은 전체 네트워크를 보강하였고 전체 생태 시스템 구조를 구축하였습니다.<br><br>Skycoin의 Fiber는 1세대 및 2세대 암호화 화폐의 구성과 경쟁하는 것이 아니라 이러한 것들을 대체합니다. 이제 갓 발을 내딛은 블록체인 프로젝트로부터 솔루션을 찾는 기업까지, Fiber가 바로 그 해답이 되겠습니다.',
      btn: 'FIBER의 더 많은 정보 알아보기',
    },
    iconLabel: {
      fiber: 'Fiber',
      coinHours: '코인 시간 ',
      cx: 'CX',
      obelisk: 'Obelisk',
      coinJoin: '코인 조인',
      skyminer: '스카이 채굴기',
      node: '노드',
      cxo: 'CXO',
      bbs: 'BBS',
      skyMessenger: 'SkyMessenger',
      skyVPN: 'SDN',
      kittyCash: 'Kitty Cash',
    },
    about: {
      heading: 'Skycoin 란?',
      paragraph1: '디지털 화폐 최초의 목적은 경제를 재정립하는 것이고 사용자들이 중심기관의 구애를 받지 않고 단독으로 권한을 부여 받아 대등한 방식으로 거래를 진행할 수 있게 하는 것이었습니다. Skycoin을 놓고 말하면, 이것이 바로 저희의 사명인 것입니다. 이것이 바로 Skycoin이 단 몇명의 소수가 아닌 모든 사용자들이 이익을 얻게 하는 취지를 세우게 된 이유인 것입니다. Obelisk를 통해 우리는 PoW와 PoS 알고리즘의 고질적 문제를 해결하고 있고 탈중앙화의 민주 합의 네트워크를 제공할 것입니다.',
      paragraph2: '나카모토 사토시는 비트 코인을 하나의 탈중앙화 디지털 화폐로 간주하였습니다. 블록체인 네트워크는 금융 민주화를 실현하고 대기업의 통제를 없애며, 권력이 사람들의 손에 장악되도록 하기 위함입니다. 그러나 비트 코인과 기타 PoW/PoS 알고리즘을 사용하고 채굴을 통해 인센티브를 받는 디지털 화폐는 점점 더 중심화로 나아가고 있다. 이것은 디지털 화폐를 발명했던 초심에 어긋나는 것입니다.',
      paragraph3: '그래서 저희는 이러한 결함들을 보완하기 위해 Skycoin을 창조한 것입니다. Skycoin의 블록체인은 전면적으로 새로운 일치성 알고리즘을 사용하여 PoW/PoS를 대체하였습니다. 뿐만아니라, 다른 블록체인과의 네트워크 연결 보안 문제를 해결하였고 새로운 코인의 출현과 채굴을 분리하였습니다. Skycoin이야말로 나카모토 사토시의 바램에 꼭 맞는, 진정한 탈중앙화 디지털 화폐인 것입니다.',
      paragraph4: 'Skycoin 블록체인에는 채굴이 없으므로 현재의 비트 코인과는 달리 몇개의 큰 마이닝 풀에 권력이 집중되는 것이 아닙니다. 새로운 코인의 출현은 네트워크를 부당하게 사용하는 일부 사용자들에게 그 통제권을 내어주지 않습니다.  Skycoin은 총량이 일정하고 거래 속도는 초단위 급으로 빠르며 안전합니다. 저희가 창조한Skycoin은 불가변적인 암호화 화폐이고 인터넷을 통제하는 정치적 도구가 아닌 디지털 자산입니다. ',
    },
    roadmap: {
      dev: {
        heading: 'Skycoin 발전 로드맵',
      },
      marketing: {
        heading: 'Skycoin Marketing Roadmap',
      },
    },
  },
  skyminer: {
    title: 'Explore Skyminer',
    description: '스카이 채굴기: 다음 세대 네트워크 하드웨어.',
    hero: {
      heading: '스카이 채굴기:<br/>다음 세대 네트워크 하드웨어.',
    },
    about: {
      heading: '스카이 채굴기 탐구',
      subheading: 'SKYWIER채굴기: 새세대 인터넷의 하드웨어 디바이스',
      paragraph1: 'Skywire채굴기는 알심들여 디자인되고 배치되어 새세대 네트워크의 구축에 버팀목을 제공해 주었습니다. Skywire 채굴기의 맞춤 제작된 하드웨이 디바이스는 현존하는 기술 표준을 초월하여 가장 높은 출력과 성능을 제공해드립니다. Skywire은 마치 Skycoin을 획득하는 채굴기와 유사하며 전문적인 가상 전용 네트워크를 위해 아래와 같은 하드웨어 사양을 보유하고 있습니다.',
      paragraph2: '매개 메인보드는 모두 ARM 처리 장치, 2GB RAM 및 32~256 GB의 플래시 메모리를 탑재하고 있습니다. 이렇게 하드웨어를 분할하는 방법은 한개 서버가 고장난 상황에서 동일한 컴퓨터의 기타 서버에 영향을 주지 않게 됩니다. 또한 엄격한 데이터 패키지 재전송 규칙 및 접근 통제의 OpenWRT 라우터는 보안성을 높여주었습니다. 본 세트의 사양은 가일층 맞춤 제작되어 4, 8, 16 혹은 32개 메인보드를 수용할 수 있습니다.',
      paragraph3: 'Skywire네트워크에서 실행되는 노드는 재전송 유통량의 보너스를 얻을 수 있는 외에, 네트워크 보너스를 획득 가능하므로 네트워크 구축에 용이합니다. Skywire 채굴기에 관해 저희는 이러한 네트워크 보너스 기능을 더한층 발전시킬 수 있기를 바랍니다. 반면 저희는 여전히 Skywire 채굴기와 기타 메커니즘의 구별하는 메커니즘을 제작하고 있으므로 이러한 노드는 네트워크 상의 모든 기계가 될 수도 있습니다.',
      list: {
        item0: '8개 CPU 메인보드 ',
        item1: '한개 메인보드당 2GB RAM 보유',
        item2: '한개 메인보드당 4개 CPU 코어 보유',
        item3: '한개 메인보드당 16GB의 저장 공간 보유',
        item4: '64비트 Linux 시스템 (Alpline Linux)',
        item5: '기가바이트 이더리움, 8 + 1 포트 스위처',
      },
    },
    video: {
      heading1: '스카이 채굴기란',
      heading2: '스카이 채굴기 소개',
      heading3: '스카이 채굴기 디배닝',
      more: '영상 더보기',
    },
    gallery: {
      heading: '사진정보',
    },
    signup: {
      heading: '스카이 채굴기 신청 리스트에 가입',
      body: '다음 세대 네트워크에서 여러분의 미래를 위해 자리를 하나 마련해두세요, 바로 오늘 말이죠!',
    },
  },
  roadmap: {
    title: 'Skycoin Roadmap',
    description: 'Skycoin Development Roadmap',
    heading: 'Skycoin Development Roadmap',
  },
  skywire: {
    title: 'Skywire',
    description: 'Skywire - The Foundation of a New Internet',
    about: {
      heading: 'Skywire 란?',
      subheading: 'SKYWIRE가 새로운 인터넷을 창립하였습니다',
      quote: '모두가 Skywire에 기여할 수 있고 또 그 과정에서 혜택을 받을 수 있습니다.',
      paragraph1: 'Skywire는 인터넷이 개발하고 사용하는 다음 혁명화 단계입니다. 저희는 인터넷 서비스 제공업체(ISP)가 시장을 독점하는 것을 타파하고 사용자가 자주권을 지니기를 바랍니다. 저희는 분산된 커뮤니티에 의해 구동되는 메쉬 네트워크를 제공함으로써 이 점을 구현하고 있습니다. 사용자는 자체로 네트워크의 기초시설을 보유하고 통제할 수 있습니다. 저희의 목표는 모든 사람들에게 빠르고 안전하며 은밀하고 신뢰할 수 있는 인터넷을 제공하는 것입니다. ',
      paragraph2: '현재는 ISP를 뒤로하고 앞을 내다볼 때가 되었습니다. 고질적 인터넷 고객들은 종종 추적 당하고 그들의 방문기록 데이터는 ISP에 의해 저장, 판매되며 동시에 신뢰할 수 없는 네트워크의 분포 및 형편없는 고객 서비스와 마주합니다. 반면 Skywire 메쉬 네트워크는 회사 소유의 네트워크에 의존하는 것이 아니라 광범위한 사용자가 소유한 노드에서 실행되고 이러한 노드가 모여서 네트워크에 기초 시설을 제공하고 커뮤니티가 인터넷에 접속할 수 있도록 합니다.',
    },
    features: {
      heading: '주요 특징:',
      speed: {
        title: '빠른 속도',
        text: '저희는 기존의 ISP 서비스를 이용할 때 모두 네트워크 지연, 중단, 그리고 쓰로틀링 등 문제에 부딪힌 적이 있습니다. Skywire의 프로토콜은 소프트웨어 정의 네트워크에 기반을 두고 있습니다. 이는 시대에 뒤떨어지고 비효율적인 핫 포테이토(hot-potato) 라우터를 역사로 남게 합니다. Skywire는 채널 바인딩을 지원하고 그 무엇보다도 빠른 연결을 실현하며 높은 신뢰성을 가지고 있어 한 번에 여러 노드에 연결할 수 있습니다. 이는 처리량과 과잉량을 크게 향상시켜 과거에는 어려웠던 애플리케이션 환경이 민주화 될 수 있게 합니다.',
      },
      privacy: {
        title: '프라이버시 보호',
        text: '임의의 엔드 투 엔드 암호화를 통해 Skywire는 모든 트래픽이 비밀적으로 이루어지도록 보장하며 사용자의 데이터는 영원히 추적, 저장, 판매될 수 없습니다. 제3자는 단일 데이터 패키지를 그 어떤 사용자나 IP 주소에 연결할 수 없으며 또 네트워크에 있는 그 어떤 콘텐츠도 읽을 수 없습니다. 중계 노드는 암호화된 데이터 패킷키지의 전송에 사용되는 직전과 직후의 노드에 대한 라우팅 정보만 얻을 수 있습니다. 사용자는 최종으로 인터넷 사용과 동시에 프라이버시를 진정으로 보호 받을 수 있는 것입니다.',
      },
      security: {
        title: '보안성',
        text: '오늘날, 인터넷 사용자들은 ISP의 운영 방식에 대해 어떠한 발언권도 없습니다. Skywire는 네트워크 신뢰성 시스템을 통해 사용자에게 재차 결정권을 부여합니다. 합의 모델하에서 노드가 악성노드로 인정될 경우에는 차단되고 해당 노드가 커뮤니티 집단 합의를 통해 신뢰성이 있다고 판단되면 그 연결이 강화됩니다. 모든 사람이 발언권을 갖도록 함으로써 Skywire는 이용당하지 않고 조종, 공격 받지 않으며 모든 사용자들에게도 더 안전한 것입니다.',
      },
      ecosystem: {
        title: '자급자족하는 생태계',
        text: 'Skywire의 핵심은 커뮤니티 자체입니다. 노드 운영자에게 Skycoin 및 코인 시간을 제공 함으로써 인센티브 조치를 취하여 사용자가 네트워크에 기여하도록 격려합니다. 이와 상응하게 사용자는 코인 시간을 획득하고 코인 시간을 사용할 때 네트워크상의 자원과 어플리케이션 서비스를 받을 수 있습니다. 네트워크는 많이 사용될수록 더 강해지고 더 빨라지며 더 안정적이고 이로써 클로즈드 루프를 조성하여 자급자족하는 생태계를 구축하는 것입니다.',
      },
      internet: {
        title: '하나의 완전히 새로운 인터넷의 기초',
        text: 'Skywire는 분산형 대역폭, 스토리지 및 컴퓨팅에 기초를 마련해주었고 이는 새로운 P2P 네트워크에게 있어 아주 중요한 것입니다. 나중에 사용자들은 이런 세가지 기능을 하나로 통합한 디지털 상품을 저렴한 가격에 구입할 수 있고 또 Skywire를 통해 쉽게 글로벌 정보를 방문할 수 있게 될 것입니다. Skywire와 어디에나 존재하는 Skywire 채굴기는 노드를 제공하고 Skycoin 구조에서 실행되는 무한한 블록체인 어플리케이션이 고효율적이면서도 탈중앙화 방식으로 실행되게 합니다.',
      },
    },
  },
  cxo: {
    title: 'CXO - CX 객체 시스템',
    description: 'CXO - CX 객체 시스템',
    about: {
      heading: 'CXO 란 ?',
      subheading: 'CX 객체 시스템',
      quote: 'Skycoin은 다음과 같은 부분을 포함하는 새로운 생태시스템을 구축하고 있는 중입니다:',
      paragraph1: 'CXO(CX 객체 시스템)는 변경 불가한 Skycoin 객체 시스템으로, 과거에는 Aether라 불러왔습니다. CXO는 현재의 전통적인 P2P 공유 방식을 대체하고 강력한 스토리지 시스템을 구축하며 BitTorrent, Dropbox와 Google Drive 등 서비스를 대체하고 Skycoin CXO 라이브러리를 통해 데이터에 관하여 P2P 복사를 진행하는 것을 목적으로 구축되었습니다.',
      paragraph2: 'CXO는 블록 체인에 기반을 둔 기타 스토리지 네트워크에 사용되는 계약을 통합하고 확장합니다. CXO는 내장 모드를 탑재한 IPLD로서, 이러한 모드는 연관 데이터베이스를 구속하고 분류하는 데 사용될 수 있습니다. 또한 IPFS(InterPlanetary File System)도 CXO 위에 구축될 수 있습니다. CXO가 제공하는 데이터는 Skywire 네트워크에 분포되어 있으므로 데이터 보안을 구현하는 것에 유리하고 검증 가능하며 블록 체인에 저장하지 않아도 됩니다.',
      skywire: {
        title: 'Skywire',
        text: 'Skywire-P2P 커뮤니티 구동형 탈중앙화',
      },
      cx: {
        title: 'CX',
        text: '규범 및 프로그래밍 언어',
      },
      cxo: {
        title: 'CXO',
        text: '데이터를 공유하고 어플리케이션을 저장하는 데 사용되는 인프라 라이브러리',
      },
    },
    features: {
      heading: '주요 기능:',
      sharing: {
        title: '데이터 공유',
        text: '공개 키와 같은 많은 정보를 공유할 수 있으므로 정보를 공유하려는 데이터 소유자에게 큰 도움이 됩니다. CXO 노드는 업데이트 된 정보들을 받기 위해 정보 소스를 구독할 수 있고 발견된 서버를 통해 연결할 수 있어 기호에 따라 연결하여 데이터를 얻을 수 있는 것입니다.',
      },
      privacy: {
        title: '프라이버시',
        text: 'CXO 데이터는 대부분 네트워크속에 존재합니다. 데이터는 일단 배포되면 파기될 수 없고 또한 동등한 사용자(구독자)들은 해당 데이터를 다운로드 하게 됩니다. 프라이버시를 보호하기 위해 작성자의 위치는 추적될 수 없습니다. 그 이유는 작성자는 단지 탈중앙화된 네트워크의 한개 노드(동등한 사용자)이기 때문이다.',
      },
      security: {
        title: '보안성',
        text: 'CXO는 자급자족하는 표준 생태시스템에 존재합니다. 해당 생태시스템은 데이터가 정확하고 0으로부터 구축된 생태시스템입니다. 소유자는 개인 키를 사용하여 데이터에 서명하고 데이터를 받는 사용자는 공개 키를 사용하여 심의하고 서명할 수 있어 데이터가 의도된 정보 소유자로부터 온 것임을 보장받을 수 있게 됩니다. 만약 데이터 소유자가 개인 키를 보유하지 않았다면 노드는 데이터를 변경할 수 없으므로 데이터의 안전을 보장해줍니다.',
      },
      apps: {
        title: 'CXO 어플리케이션',
        text: 'CXO의 어플리케이션은 현재 소량의 테스트를 진행하고 있습니다. SkyBBS는 Facebook, Steemit 및 Twitter와 유사한 소셜 네트워크이며 CXO위에 구축 되어있습니다. 곧 출시될 더 많은 어플리케이션을 기대해주시기 바랍니다.',
      },
    },
  },
  cx: {
    title: 'CX - 프로그래밍 언어 ',
    description: 'CX - 프로그래밍 언어 ',
    about: {
      heading: 'CX란?',
      subheading: '프로그래밍 언어 ',
      paragraph1: 'CX는 규범화된 Skycoin인 동시에 프로그래밍 언어로서 다양한 기능을 갖추고 있습니다. CX는 Skycoin프로젝트에서 더 개선된 서비스를 제공해 드릴 것입니다. CX는 보안성이 필요되는 복잡한 계약을 생성할 수 있습니다.',
      paragraph2: 'CX는 플랫폼을 기반으로 한 프로젝트에 관해 수정 가능한 의무를 제공합니다. 이러한 특성은 모두 CX의 다용도 프로그래밍 언어의 일부분입니다:',
    },
    features: {
      heading: 'CX의 특성:',
      affordances: {
        title: '제공성',
        text: '특정 사용자들은 제공성을 활용하여 패키지의 권한을 허가하거나 거절할 수 있으며 이로써 프로그래머가 안전한 코드를 생성할 수 있도록 보장합니다. 또한 기능내 조작 목록을 얻기 위한 제공성 시스템 조회가 가능합니다.',
      },
      programming: {
        title: '유전 프로그래밍 (GP)',
        text: '유전 프로그래밍은 CX 프로그램 생성 과정속에서 발전된 것입니다. 기계 학습 도구로서의 GP는 문제 해결 자동 메커니즘을 제공하는 것과, 곡선 맞춤을 실행하고 예측 모형을 생성하는 능력을 통해 프로그래머에 협조합니다.',
      },
      deterministic: {
        title: '확정형 언어',
        text: '확정성은 CX 프로그램이 신뢰성을 기초하여 생성되도록 합니다. 하여 프로그래머는 내장 환경속의 기반 기계에 신경을 쓰지 않아도 됩니다. 즉, 출력은 기계에 상관없이 언제든지 생성될 수 있다는 뜻입니다.',
      },
      typing: {
        title: '엄격한 타이핑 시스템',
        text: 'CX의 엄격한 타이핑 시스템은 다른 레이어 혹은 예비 시스템을 제공하는동시에 디버깅 과정을 단순화하여 사용에 편리를 제공하였습니다. 명확한 형변환은 오류를 줄여주고 프로그래머들을 위해 본질적으로 CX의 안전성을 보장해주었습니다.',
      },
      complied: {
        title: '컴파일러 언어 및 해석형 언어',
        text: '컴파일러 언어 및 해석형 언어의 기능을 모두 갖추었으므로 프로그래머는 상응한 선진 기능 및 유연성과 상호 작용성을 갖춘 부가 기능을 활용할 수 있습니다.',
      },
      garbage: {
        title: '가비지 컬렉터',
        text: 'CX가비지 컬렉터는 자동 메모리 관리 형태로서, 큐에서 사용하지 않은 대상을 자동으로 회수하여 필요한 조작을 위해 중요한 메모리 공간을 비워둡니다. 또한 CX는 프로그램에서 접근 불가한 데이터 대상을 찾아내어 처리합니다.',
      },
      object: {
        title: '객체 탐색기',
        text: '프로그래머는 전부 객체와 해당 메모리 할당을 그래픽뷰로 보여주는 객체 탐색기에 방문할 수 있는 권한을 가지게 됩니다. 이러한 객체는 직렬화될 수 있고 전송될 수 있습니다. 코드 스테핑은 프로그래머가 최종 관찰 단계에서 그러한 객체의 실행을 회복하도록 허가합니다.',
      },
    },
    roadmap: 'Skycoin로드맵',
  },
  jobs: {
    title: 'Skycoin is hiring developers.',
    subtitle: 'We are hiring',
    sidebarTitle1:
      'Apply for a job by sending an email to jobs@skycoin.com with the following information:',
    sidebarTitle2: 'with this information:',
    sidebarList: {
      item_1: 'Position desired',
      item_2: 'Name',
      item_3: 'Time zone',
      item_4: 'Full-time or part-time',
      item_5: 'Telegram username',
      item_6: 'Resume (PDF)',
    },
    ourProject:
      'All of our projects are developed in Go and C. For frontend work, we use ',
    angular: 'Angular',
    or: ' or ',
    react: 'React.js.',
    ourTeam:
      'Our team is spread across the world and you will be working either remotely or at one of our offices in Shanghai. We communicate using',
    accordion1: {
      title: 'Technical Writer',
      responsibilities: {
        title: 'Responsibilities',
        item1:
          'Work on a remote team to create articles to communicate technical progress to readers',
        item2: 'Create and update technical documentation',
        item3: 'Create user manuals for various Skycoin projects',
      },
      requirements: {
        title: 'Requirements',
        item1:
          'Excellent English reading and writing skills as well as previous experience with technical writing.',
        item2:
          'Knowledge of concepts and technologies used in the software development process.',
      },
    },
    accordion2: {
      title: 'Software Engineer (Backend)',
      description:
        'Work on a fully remote team developing blockchain-, networking- and infrastructure-related software. Experience writing in Go (Golang) required.',
      projects: {
        title: 'A Sample of Active Projects',
      },
    },
    accordion3: {
      title: 'Firmware Engineer',
      description:
        'Work on a fully remote team developing firmware and embedded software for various hardware projects.',
      projects: {
        title: 'A Sample of Active Projects',
      },
    },
    accordion4: {
      title: 'Circuit Engineer',
      description:
        'Study relevant technical materials to compile the proper English materials for foreign members making up 80% of total team members. Good proficiency in English reading and writing is a requirement for admission.',
      responsibilities: {
        title: 'Responsibilities',
        item1:
          'Draw PCB Design drawing and circuit schematic diagram according to product requirements;',
        item2:
          'Edit the instruction documents for production, such as BOM format and screen mesh;',
        item3:
          'Carry out the selection of components and be in tune with suppliers on product supply;',
        item4: 'Carry out type testing and reliability testing;',
        item5: 'Write technical documents and file them.',
      },
      requirements: {
        title: 'Requirements',
        item1:
          "Hold a bachelor's degree or above in electronic engineering or related discipline;",
        item2:
          'Possess very strong English reading and writing skill in response to the search and quick study of technical materials and the daily conversation in an English-speaking environment;',
        item3:
          'Process the ability to proficiently design analog circuits and digital circuits, and read and draw schematic diagram skillfully;',
        item4:
          'Use Altium Designer or other same type software skillfully in response to the independent conduct for layout design of four-layer PCB board.',
        item5:
          'Possess the strong ability to circuit adjustment and test, and use common instruments skillfully;',
        item6:
          'Have a certain understanding of the model and supply chain of ordinary electronic components;',
        item7:
          'Think clearly, take initiative in working process, hold the ability in both strong executive and excellent self-study, and maintain good teamwork spirit.',
      },
      priority: {
        title:
          'High-priority candidates include those with any of the following conditions',
        item1:
          'Possess the ability to be familiar with English materials on Electronics Industry or the English-speaking proficiency;',
        item2:
          'Enable to use SolidWorks and other same types of 3D modeling software and to read mechanical drawings;',
        item3:
          'Have experience in the development of mechanical control programs, Raspberry Pi or Arduino;',
        item4:
          'Have knowledge or experience in any one of the following three sectors--- the Internet of things, communication, and integrated circuits;',
        item5: 'Understand the knowledge of blockchain well;',
      },
      program: {
        title: 'Internship Program',
        item1:
          'Submit at least one work about PCB Design, and relevant cites must be marked if any;',
        item2:
          'Welcome to all of outstanding undergraduates and fresh graduates to take part in internship plan. Upon completion of the internship period, satisfactory trainees shall be given permanent posts.',
      },
    },
    accordion5: {
      title: 'Mechanical Engineer',
      description: 'Description',
      study:
        'Study relevant technical materials to compile the proper English materials for foreign members making up 80% of total team members. Good proficiency in English reading and writing is a requirement for admission',
      responsibilities: {
        title: 'Responsibilities',
        item1:
          'Engage in design, study and optimization for the structure of mechanical products, creation of products, and improvement of product performance and quality;',
        item2:
          'Choose component, set up model machine, test product, and provide technical support for subsequent development work;',
        item3:
          'Solve problems during product development work and meet new requirement from users;',
        item4:
          'Provide the volume production of products with relevant technical data;',
        item5:
          'Play an active role in other aspects of company business needs.',
      },
      requirements: {
        title: 'Requirements',
        item1:
          "Hold a bachelor's degree or above in mechanical engineering or related discipline;",
        item2:
          'Possess very strong English reading and writing skill in response to the search and quick study of technical materials and the daily conversation in an English-speaking environment;',
        item3:
          'Use SolidWorks or related software proficiently in response to the independent conduct for establishment, modification and derivation of model. Experience in designing and managing model documents with components whose total volume is more than 100 are preferred;',
        item4:
          'Understand the supply chain of ordinary mechanical components well;',
        item5:
          'Think clearly, take initiative in working process with the ability in both strong executive and excellent self-study, and maintain good teamwork spirit.',
        item6: 'Must be on site in Shanghai.',
      },
      priority: {
        title:
          'High-priority candidates include those with any of the following conditions',
        item1:
          'Possess the ability to be familiar with English materials on machinery industry or English-speaking proficiency;',
        item2:
          'Understand circuit knowledge and use Altium proficiently for completing the PCB Design;',
        item3:
          'Have experience in the development of mechanical control programs, Raspberry Pi or Arduino;',
        item4: 'Understand the knowledge of blockchain well;',
      },
      propgram: {
        title: 'Internship Program',
        item1:
          'Submit at least one model completed by using Solidworks, and relevant cites must be marked if any;',
        item2:
          'Welcome to all of outstanding undergraduates and fresh graduates to take part in internship plan. Upon completion of the internship period, satisfactory trainees shall be given permanent posts.',
      },
    },
    accordion6: {
      title: 'Industrial Designer OR Intern',
      description: 'Description',
      subtitle:
        'Study relevant technical materials to compile the proper English materials for foreign members making up 80% of total team members. Good proficiency in English is a requirement for admission',
      responsibilities: {
        title: 'Responsibilities',
        item1: 'New product exterior design and 3D modeling;',
        item2:
          'Choose component, set up model machine, test product, and provide technical support for subsequent development work;',
        item3:
          'Provide the volume production of products with relevant technical data;',
        item4:
          'Play an active role in other aspects of company business needs.',
      },
      requirements: {
        title: 'Requirements',
        item1:
          "Hold a bachelor's degree or above in product design or related discipline;",
        item2: 'Have had one-year experience working in relevant sector;',
        item3: 'Have fluent English speaking, reading and writing;',
        item4:
          'Use SolidWorks or relevant 3D modeling software skillfully in response to the independent conduct for establishment, modification and derivation of model.',
        item5:
          'Possess the ability to be familiar with processing technology of common materials, and have a certain understanding of the supply chain for relevant parts;',
        item6:
          'Possess the ability to outstanding aesthetic judgment and creative thinking skill, take initiative in working process, good cooperation spirit and will of study. ',
        item7: 'Must be on site in Shanghai.',
      },
      priority: {
        title:
          'High-priority candidates include those with any of the following conditions',
        item1:
          'Possess the ability to read mechanical drawings or electrical drawings;',
        item2:
          'Use Adobe Illustrator or other same type graphic design software proficiently;',
        item3: 'Understand the knowledge of blockchain well;',
      },
      program: {
        title: 'Internship Program',
        item1:
          'Submit at least one design work completed independently and its introduction;',
        item2:
          'Welcome to all of outstanding undergraduates and fresh graduates to take part in internship plan. Upon completion of the internship period, satisfactory trainees shall be given permanent posts.',
      },
    },
    accordion7: {
      title: 'Blockchain Internship Engineer',
      description:
        'Carry out 90% of the tasks in English and work together with English-speaking members making up 80% of total team members. Good communication skills and proficiency in English are requirements for admission; experiences in large international companies are preferred. Upon completion of the internship period, satisfactory trainees shall be given permanent posts.',
      responsibilities: {
        title: 'Responsibilities',
        item1:
          'Study the principle of blockchain, operation mechanism and relevant algorithms;',
        item2:
          'Take part in the design, development and testing of blockchain products;',
        item3:
          'Solve problems during development and testing, and provide technical support for products;',
        item4: 'Write technical documents and file them.',
      },
      requirements: {
        title: 'Requirements',
        item1:
          'Undergraduates and fresh graduates majoring in computer science, software engineering, or related specialists;',
        item2:
          'Process the outstanding ability to excellent communication skills and good English reading and writing skills, and to learn code and relevant technical materials well;',
        item3:
          'Be passionate about the programming, be fond of studying technique, and be strongly interested in the blockchain technology;',
        item4:
          'Be proficient in at least one of the following sectors--- C/ C++, JAVA, GoLang, and Swift Programming Language development, and have good habits of programming and proficiency in file compilation;',
        item5: 'Have experience in developing Linux platform;',
        item6:
          'Master the technique in data structure and algorithm, and be familiar with network protocols such as TCP/IP, HTTP and P2P;',
        item7:
          'Think clearly, take initiative in working process, hold the ability in excellent self-study, and maintain good teamwork spirit.',
        item8:
          'Submit your GitHub account and at least one work, and relevant cites must be marked if any;',
      },
      priority: {
        title:
          'High-priority candidates include those with any of the following conditions',
        item1:
          'Possess the ability to be familiar with relevant professional English vocabularies, and to communicate and express English freely;',
        item2:
          'Have experience in research, development and practitioner of the projects related to blockchain;',
        item3:
          'Have experience in the network protocol development, such as DNP, P2P, etc. ',
      },
    },
    accordion8: {
      title: 'Operations Manager',
      description:
        'This is a flexible position. The operations manager will be responsible for improving internal business processes and leading teams for various business goals as needed. Strong communication and organizational skills are required. Work position is remote or on-site in Shanghai.',
    },
    accordion9: {
      title: 'Marketing Manager',
      responsibilities: {
        title: 'Responsibilities',
        item1:
          'Build, optimize and scale effective marketing campaigns to drive growth across digital marketing channels',
        item2:
          'Identify and test new innovative growth opportunities to deliver on goals',
        item3: 'Collaborate with internal teams / vendors',
        item4: 'Manage performance metrics and budget tracking',
        item5:
          'Generate and create data driven hypotheses to execute experiments across the marketing funnel to optimize conversion and other key performance metrics',
        item6:
          'Execute global marketing strategies with integrated campaigns focusing on user acquisition and brand awareness',
        item7:
          'Coordinate with content writers and social media manager to ensure message consistency across various channels',
        item8:
          'Tell stories with data, transforming it into insightful and easy to interpret visuals',
        item9: 'Maintain brand voice, design and messaging',
        item10:
          'Work closely with the Product and Engineering teams to launch features and products',
      },
    },
    accordion10: {
      title: 'Social Media Manager',
      responsibilities: {
        title: 'Responsibilities',
        item1: 'Represent our brand on social media channels',
        item2:
          'Deliver engaging and inspiring messages to our social audiences, with the goal of driving brand awareness and consideration',
        item3: 'Significantly grow our audience on social media',
        item4: 'Define and implement paid and organic growth strategies',
        item5:
          'Turn our high level marketing strategy into a social media strategy and calendar',
        item6: 'Prioritize between channels, posts and messages',
        item7:
          'Work together with influencers, internal, and external teams to build social content that engages and inspires large customer audiences',
        item8: 'Scale our social content across multiple markets and languages',
        item9: 'Drive engagement with our social community',
        item10:
          'Ensure communication excellence and convert audience feedback into reputation/brand-building moments',
        item11:
          'Drive and develop customer understanding through insightful analyses and actionable reporting',
        item12:
          'Work closely together with the marketing manager to drive a consistent and differentiated brand message to a mix of countries and audiences',
      },
    },
    accordion11: {
      title: 'Content Writer',
      requirements: {
        title: 'Requirements',
        item1: 'Strong knowledge in various media and marketing channels',
        item2: 'Must be able to write content that is SEO friendly',
        item3:
          'Candidate needs to be self-motivated, detail-oriented, problem solving and able to work as a team with staff and administrators; have excellent communication and organization skills',
        item4: 'Must have a popular blogging experience',
        item5: 'Highly proficient in Cryptocurrency and blockchain technology',
        item6: 'Adobe Photoshop basic skills',
        item7: 'Creative thinking skills',
        item8:
          'Strong proficiency in the English language and excellent writing skills',
        item9:
          'Ability to translate complex technical concepts into easily comprehensible articles',
        item10: 'Excellent writing, analysis, and research skills',
      },
    },
    accordion12: {
      title: 'SEO Engineer',
      description:
        'The SEO Engineer will devise and implement SEO strategies on our website properties and in external SEO campaigns.',
    },
  },
  whitelist: {
    heading: 'Skywire Testnet Reward Application Form',
    signUp: {
      title: '로그인 하시고 Skycoin 테스트 넷에 가입하셔서 보너스를 얻으세요!',
    },
  },
  fiber: {
    title: 'Fiber',
    description: 'Fiber is Blockchain 3.0 Innovation with Advanced Peer-Chain Architecture',
    about: {
      heading: 'Fiber란?',
      subheading: '블록체인 3.0 혁신 및 선진적인 동등 체인 구성',
      quote: '“Skycoin의 Fiber 구성은 하나의 혁명성적이고 블록체인보다 더 뛰어난 솔루션입니다. 분산 원장 기술을 사용하여 현재 존재하는 문제들을 해결한 것입니다. Fiber은 블록체인 3.0의 기반이 되어 마치 하나의 나란히 설치된 스트랜드와도 같은, 무한 신축가능한 블록체인 네트워크로 가장 잘 묘사됩니다. 이러한 것들은 비트코인이나 이더리움 등 암호 화페로써는 영원히 실현할 수 없는 기술적 위업입니다. 암호 화페는 단 한번도 무한한 규모로 디자인 된 적 없기 때문이죠.”',
      author: '언론 매체',
      paragraph1: 'Fiber은 Skycoin블록체인 플랫폼의 구조층으로서 모든 블록체인 어플리케이션의 수요에 모두 적용될 수 있도록 맞춤 제작 되었습니다. 하나의 창신적이고 극히 효과적인 코드로 실행되는 Fiber은 Skycoin플랫폼이 블록체인 솔루션을 통해 모든 업체로 확장되는 동시에 모든 업체를 확실하게 뒤엎을 수 있도록 하였습니다.',
      paragraph2: 'Fiber은 정교하면서도 세련되었습니다. Fiber은 다양한 분산형 어플리케이션의 수요를 확장시키면서도 그 수요에 적응해나갈 수 있습니다.',
    },
    features: {
      heading: 'Fiber의 우세',
      system: {
        title: '진정한 공생 동등 체인 시스템',
        text: 'Skycoin의 Fiber 구조는 Skycoin플랫폼에 관하여, 규모적으로 의존 관계의 파괴나 네트워크 허점이 없이 가로 및 세로방향의 변형을 실현할 수 있습니다. Skycoin의 <a href="https://medium.com/skycoin/skycoin-obelisk-8cc32bc9ca37" target="_blank" rel="noopener noreferrer">Obelisk</a> 합의 메커니즘으로 하여 Fiber이 지원하는 모든 토큰은 근본적으로 기타 토큰과 고립됩니다. 하여 이러한 것들은 기타 네트워크 안정성, 보안성 혹은 취급량 등에서 서로 영향을 주지 않는 것입니다. 이외에, Skycoin의 <a href="https://medium.com/skycoin/skycoin-coin-hours-f537fa7ae614" target="_blank" rel="noopener noreferrer">코인 시간</a> 시스템을 통해 Fiber을 활용한 모든 프로젝트는 현재 존재하는 플랫폼의 운영을 저애하지 않는 전제하에서 전체 Skycoin 플랫폼의 발전을 추진합니다. Fiber은 프로젝트들 사이에서 전례없는 높은 수준의 공생을 창조해낸 동시에 충분한 고립성을 유지하여 어떠한 토큰도 네트워크의 기타 부분에 소극적인 영향을 끼치지 않도록 하였습니다.',
      },
      forking: {
        title: '정확한 포킹 처리',
        text: 'Fiber에서 실행되는 토큰은 Skycoin 핵심 코드의 분기점으로 될 것입니다. 즉 모든 프로젝트가 Skycoin과 비슷한 레벨의 선진 기능, 취급량, 안정성 및 보안성을 갖추게 된다는 것을 의미하는 것입니다.',
      },
      blockchain: {
        title: '맞춤 제작형 블록체인',
        text: 'Skycoin Fiber에서 실행되는 프로젝트는 자체의 충분히 독립되고 높은 수준으로 맞춤 제작 가능한 블록체인을 갖추어 그들의 특별한 수요를 만족시킬 것입니다. 이것은 근본적으로 한개 세트의 규정이나 조작이 다양한 프로젝트의 요구를 만족시킨다고 가정할 때, 적응성은 가로 및 세로 방향으로의 성공적인 변형에 초점을 맞춘 블록체인 플랫폼의 결정적인 요소로 될 수 있음을 의미하는 것입니다.',
      },
      token: {
        title: '진정한 토큰 지원',
        text: 'Skycoin Fiber 구조를 기초로 하여 상장된 코인은 전례없는 네트워크의 지원을 받게 됩니다. 토큰은 저희의 획기적인 P2P 네트워크, Skywire에서 실행될 수 있을 것이며 매개 토큰은 Skycoin 생태 시스템에서 직접 월렛과 환전 지원을 받게 됩니다. 하여 저희 세계 최상급 플랫폼에서는 프로젝트의 출시 및 거래를 단 몇분내에 실현할 수 있는 것입니다. ',
      },
      operation: {
        title: '독립적인 운영',
        text: 'Skywire이 세계적인 P2P 메쉬 네트워크로 발전하면서 Skywire에서 실행되는 Fiber 토큰은 인터넷 서비스 사업자(ISP)와 같은 전통적인 네트워크 기반 시설에 대한 의존으로부터 완전히 독립됩니다. 하여 저희 플랫폼의 독립성은 Skycoin Fiber, 분산형 어플리케이션 그리고 프로젝트의 유니크한 특성입니다.',
      },
    },
  },
  skyminerForm: {
    title: 'Skyminer Order Information',
  },
  obelisk: {
    title: 'Obelisk',
    description: 'Obelisk - 혁명성적인 SKYCOIN의 합의 알고리즘',
    about: {
      heading: 'Obelisk란?',
      subheading: '혁명성적인 SKYCOIN의 합의 알고리즘',
      quote: '“중심화 문제, 51%의 공격, 채굴 문제, 거래속도의 더딤 및 에네르기 낭비는 과거 합의 알고리즘이 마주한 몇가지 결정적인 허점이었습니다. 이러한 문제를 해결하기 위해 Skycoin에서 개발한 Obelisk는 신형 분포식 합의 알고리즘으로 앞세대 사람들이 마주한 문제를 해결하였습니다.”',
      author: '언론 매체',
      paragraph1: 'Obelisk는 하나의 혁명성적인 web-of-trust 합의 알고리즘으로서 앞세대 합의 알고리즘이 블록체인 공간에서 일으킨 문제를 해결하기 위해 사용됩니다. Web-of-trust 메커니즘 구조는 완벽한 점검 및 평형 시스템을 구축하였으며 커뮤니티와 기타 노드에서 비교적 높은 정확성으로 네트워크 행위를 평가하도록 해주었습니다.',
      paragraph2: '악의적 행위에 연관되는 의심스러운 노드를 차단하는 기능과 함께 네트워크는 더한층 강대해졌으며 신뢰성 또한 보장됩니다. 노드를 차단하는 것은 신뢰성을 보장할 수 있는 동시에 이러한 과정은 커뮤니티로 하여금 네트워크의 권력을 다시금 균형시킬 수 있게 합니다.',
    },
    features: {
      heading: 'Obelist의 특성',
      consumption: {
        title: '낮은 에너지 소비 및 높은 가변성',
        text: '합의 알고리즘은 확대 및 축소가 가능하며 컴퓨팅 원가가 저렴한 작업 증명(PoW)의 대체 방안으로 디자인 되어 알고리즘과 블록 메이킹 모두 저렴한 오픈 소스 하드웨어에서 실행될 수 있습니다.',
      },
      attack: {
        title: '51% 공격을 방어',
        text: 'Web-of-trust의 합의 알고리즘은 중심화 집권의 발전을 제지합니다. Skycoin은 채굴 인센티브에 의존하지 않으므로 PoW/PoS 허점의 영향을 받지 않습니다.',
      },
      defence: {
        title: '강한 방어력',
        text: 'Obelisk는 잘 조직된 네트워크를 통해 악의적인 노드의 대규모 협동 공격에 대응할 수 있습니다. 이러한 알고리즘은 비반복적인 것으로 빠르게 집성되어 메쉬 네트워크와 유사하게, 유일한 최근접 연결로써 노드의 희소한 배열방식을 통해 실행됩니다.',
      },
      structure: {
        title: '이중 노드 구조',
        text: '한개 합의 노드는 한개 혹은 여러개 블록 메이킹 노드로부터 해당 입력을 전송 받습니다. 매개 알고리즘은 모두 독립적인 것이지만 모두 동일한 데이터 구조에서 실행됩니다. 두가지 유형의 노드는 모두 입력된 데이터에서 저작권 증명 및 이상 금융거래를 탐지합니다. 하여 비합법적이거나 인식 불가한 메세지는 모두 탐지되고 처리되어 절대 전파될 수 없습니다. 하여 의심스러운 행위에 연루되는 대등한 노드들은 전부 차단되며 해당되는 공개 키 또한 정지 됩니다.',
      },
    },
  },
  gallery: {
    title: 'Gallery',
    description: 'Gallery',
    heading: 'Gallery',
    antennas: {
      heading: 'Biquad Yagi Antenna',
    },
    wallet: {
      heading: 'Skywallet',
    },
    skyminer: {
      heading: 'Skyminer',
    },
    diySkyminer: {
      heading: 'DIY Skyminers',
    },
  },
  landing: {
    skyware: {
      hero: {
        title: 'Skywire',
        heading: 'Skywire is the next evolutionary step in the internet’s development and use. Our goal is to provide everyone with access to fast, secure, private and reliable internet.',
        button: 'Learn more',
      },
      watchNow: {
        title: 'Watch now!',
        description: 'Check out these YouTube videos to learn more about Skywire',
        youtube: {
          what: 'What is Skywire?',
          solution: 'A Solution to Censorship',
          isp: 'Why ISPs need to be Replaced',
        },
      },
      afee: {
        text: '“To free Crypto from the bonds of corrupt power, we need more than distributed exchanges. We need to bypass the existing Internet. Mesh networks solve this problem. Skywire  is the only one designed by and for the Crypto Space.” ',
        name: 'John McAfee',
      },
      divider: 'Everyone will be able to contribute to and benefit from Skywire',
      bottom: {
        text: 'Its <b>private</b>, <b>secure</b> and <b>decentralized</b>. Join over 1,450+ nodes now on Skywire with our current special promotion!',
      },
      features: {
        speed: {
          title: 'Speed',
          description: 'Skywire’s protocol is based on software-defined networking, which will make the outdated and inefficient  “hot-potato” packet routing a thing of the past.',
        },
        privacy: {
          title: 'Privacy',
          description: 'With default end-to-end encryption, Skywire ensures that all traffic is private and users will never have  their data tracked, stored, or sold.',
        },
        security: {
          title: 'Security',
          description: 'Today, internet users have no say in how ISPs operate. Skywire gives this decision making power back to  the community in the form of a web-of-trust system.',
        },
        ecosystem: {
          title: 'Self-sustaining ecosystem',
          description: 'By providing Skycoin and Coin Hour rewards to  node operators, we offer incentives for people to contribute to the network.',
        },
        internet: {
          title: 'Foundation of the new internet',
          description: 'Skywire lays the foundation for distributed bandwidth, storage, and computation essential to the new  peer-to-peer internet',
        },
      },
    },
    cx: {
      hero: {
        title: 'CX',
        heading: 'CX is Skycoin\'s specification and programming language, packed full of features. It allows for the creation of complex contractual agreements that are build with security in mind.',
        button1: 'Download now',
        button2: 'Learn more',
      },
      watchNow: {
        title: 'Watch now!',
        description: 'Check out the video below to get an introduction on the CX programming language by the lead developer Amaury Aguila. ',
        youtube: {
          introduction: 'CX Introduction',
        },
      },
      start: {
        title: 'Start now!',
        description: 'Download CX now and start working on a project.  Join the CX group on Telegram to share your work, get help, gain inspiration and much more.  There is even a group dedicated to making games with CX.',
      },
      divider: 'CX will provide numerous advancements within the Skycoin project.',
      features: {
        affordance: {
          title: 'Affordances',
          description: 'The utilization of affordances allows the permission of packages to be granted or rejected from specific users, aiding in the ability of programmers to confidently create secure code.',
        },
        typing: {
          title: 'Strict typing system',
          description: 'Explicit type casting reduces errors and makes CX constitutionally secure for programmers.',
        },
        object: {
          title: 'Object explorer',
          description: 'Programmers will have access to an object explorer which will show a graphical view of all objects and their current memory allocation.',
        },
        more: {
          title: 'More features...',
          list: {
            deterministic: 'Deterministic language',
            compiled: 'Compiled & interpreted language',
            extensive: 'Extensive documentation',
            active: 'Active development',
            videogame: 'Video game development',
            system: 'Mac, Linux and Windows support',
          },
        },
      },
      bottom: {
        text: 'Start developing now with CX. Either download it from Github or try the CX playground.',
        button1: 'Download',
        button2: 'CX Playground',
      },
    },
    skywallet: {
      hero: {
        title: 'Skywallet',
        heading: 'Your hardware multi-coin wallet is your bank vault and it should feel like a premium and secure device.  Shipping Q1 2019. Order now!',
        button: 'Order now',
      },
      features: {
        live: {
          title: 'Skywallet Live',
          description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna.',
        },
        security: {
          title: 'Security',
          description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. ',
        },
        support: {
          title: 'Customer support',
          description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. ',
        },
        intuitive: {
          title: 'Intuitive',
          description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. ',
        },
        included: {
          title: 'Included',
          description: 'TODO',
        },
      },
    },
    skyminer: {
      title: 'Skyminer',
      description: 'Skyminer',
      hero: {
        title: 'Skyminer',
        heading: 'The Skywire "miner" is meticulously designed and configured to provide a backbone for the new internet.',
        button: 'Learn more',
      },
      hardware: {
        title: 'Hardware',
        description: `
          <li>8 CPU boards</li>
          <li>2 GB of RAM per board</li>
          <li>4 CPU cores per board</li>
          <li>16 GB of storage per board</li>
          <li>64-bit Linux (Alpine Linux)</li>
          <li>100 Mbps Ethernet, 8+1 port switch</li>
        `,
      },
      operate: 'Operate your Skyminer on the Skywire network to <b>get paid</b> SKY for free!',
      watchNow: {
        title: 'Watch now!',
        description: 'Check out these YouTube videos to learn more about Skyminers',
        youtube: {
          video1: 'What is a Skyminer?',
          video2: 'Unboxing the Skyminer',
          video3: 'Introducing the Skyminer',
        },
      },
      support: {
        title: 'Excellent support',
        description: 'When purchasing a Skyminer you will get access to fast email support from our help desk ticket system.  Our Telegram community offers help as well with over 2000 members.',
      },
      orderNow: {
        text: `Its <b>private</b>, <b>secure</b> and <b>decentralized</b>. 
          Join over 1,450+ nodes now with our current special promotion!`,
      },
      forbes: {
        description: '“Skycoin aims to provide a new internet that is global, decentralized, and not controlled by any country, corporation or government. For privacy gurus or net neutrality enthusiasts… this is a project to stay on top of.”',
      },
    },
  },
  exchanges: {
    any: 'Any',
    title: 'Exchanges',
    description: 'Exchanges',
    exchanges: 'Exchanges',
    empty: ' ',
    lbank: 'LBank',
    c2cx: 'C2CX',
    bitbns: 'Bitbns',
    xbts: 'XBTS',
    coindcx: 'CoinDCX',
    table: {
      headers: {
        name: 'Name',
        link: 'Link',
        markets: 'Markets',
      },
    },
  },
  pressreleases: {
    any: 'Any',
    title: 'Press Releases',
    description: 'Press Releases',
    pressreleases: 'Press Releases',
    releases: {
      title: 'Skycoin Announces Public Release of Skywire Mainnet',
      description: 'Skycoin Announces Public Release of Skywire Mainnet',
      dates: 'March 20, 2019',
      content: {
        description: '<p>Skycoin has unveiled the developer version of their Skywire application. Developers will now be able to download, install, build, and run the Skywire mainnet utilizing a command line interface. Full developer documentation will be released over the next few weeks.</p><p><strong>SHANGHAI, March 19, 2019 /PRNewswire/ </strong>-- Work on Skycoin began in 2011 with the merging of three separate projects that aimed to improve upon the design and implementation of Bitcoin. The Skycoin developers identified several major philosophical design issues that they saw as obstacles to global use of cryptocurrency as a censorship-resistant payment system.</p><p>Skywire, the decentralized internet protocol and mesh network, was created as a solution to answer many of these problems.</p><p><strong>Skywire Mainnet is here for Developers to Test</strong></p><p>After about ten months of intensive testing on a network of nearly 10,000 nodes spanning the globe, Skycoin is happy to announce that the developer version of Skywire&apos;s mainnet is now available to the public. Its official launch date was the 4th of March 2019.</p><p>This first iteration of Skywire&apos;s mainnet features entirely rewritten software from the ground up and is primarily focused on a platform for developers to start building the next generation of distributed apps. All existing apps have been rewritten and optimized for the mainnet including a distributed and secure chat app, SSH, and a multi-hop tunneling proxy app. Many more will be coming soon.</p><p> <a href="https://www.blog.skycoin.com/posts/skywire-mainnet-public-testing-announcement/" rel="noopener noreferrer" target="_blank">This first version of Skywire&apos;s mainnet represents a huge milestone for Skycoin and for the future of the internet.</a> Skywire will serve as an unstoppable, highly resilient network, removing any possibility of censorship. </p><p>Skywire mainnet&apos;s developer build is the first release of many. Over the course of the next few months, Skycoin will be releasing new iterations and features for Skywire – one of these is an updater that allows Skycoin to push new features constantly – stay tuned for additional information, technical details, and further updates from the team.</p><p> <a href="https://github.com/skycoin/skywire/tree/mainnet" rel="noopener noreferrer" target="_blank">Skywire Mainnet on Github</a> </p><p>Please note: Do not install this on your skyminers as they are running testnet and will stop receiving rewards. Skywire mainnet can be installed on any other device to run, test and develop.</p><p>Bug reporting should be done through the repo, with steps taken to reproduce any feedback. Details of the process will be available in the readme section of the branch.</p><p><strong>What&apos;s Next for Skywire?</strong></p><ul> <li>A new and intuitive UI for developers and users to easily interact with the mainnet</li><li>Bandwidth monetization will be coming soon that will allow users to earn Coin Hours through bandwidth sharing</li><li>Coin Hours bank</li><li>Private Skycoin transactions utilizing CoinJoin</li><li>Remote management of unlimited nodes</li><li>Combining the CXO protocol with Skywire for distributed data storage</li></ul> <p><strong>About Skycoin</strong></p><p>Skycoin is a third generation blockchain company that has its own chain, consensus algorithm, programming language, hardware, and their flagship product Skywire which is a decentralized community-driven mesh network where users themselves will own and control the network&apos;s infrastructure. Skywire&apos;s goal is to provide everyone with access to fast, secure, private and reliable internet.</p>',
      },
    },
    releases_part: {
      title: 'Early Bitcoin and Ethereum Developers Set to Roll-Out "Skywire" - a New, Decentralized Internet from Skycoin',
      description: 'Early Bitcoin and Ethereum Developers Set to Roll-Out "Skywire" - a New, Decentralized Internet from Skycoin',
      dates: 'August 23, 2019',
      content: {
        description: '<p>Skywire is Designed to Eliminate the Privacy and Security Issues Found on the Internet</p><p><strong>SHANGHAI, CHINA / ACCESSWIRE / August 23, 2019 /&nbsp;</strong>After nearly a decade of development, the team behind the third-generation cryptocurrency Skycoin are ready to unveil their groundbreaking flagship project: a new, decentralized Internet called Skywire. Built from the ground up using cutting-edge new technology, Skywire was designed to completely eliminate the privacy and security deficiencies of the Internet as everyone knows it.</p><p>“Skycoin has created the foundation for a new decentralized Internet and the most advanced blockchain application platform in the world,” a spokesperson for Skycoin said, adding that over 10,000 hardware nodes have already been deployed for Skywire around the globe. These nodes, part of sophisticated custom hardware and software called Skyminers, form the backbone of this new Internet. More Skyminer nodes coming online means that the potential reach of Skywire is growing.Skywire is designed to be fundamentally faster than the current Internet, as well as much more secure with unprecedented privacy protection. “All traffic on Skywire is encrypted end-to-end,” said a spokesperson. “The technology we’ve developed makes tracking or spying on users literally impossible. The kinds of privacy violations we’ve seen from Facebook and Google simply couldn’t happen on Skywire.” That’s great news for the increasing number of Internet users who are uncomfortable with the invasive and obscure policies of social media companies, and wish to have greater control over who has access to their private data, and how it is used.</p><p>Skywire technology includes putting the hardware infrastructure for Skywire directly into the hands of its users, which will eventually eliminate the need for Internet Service Providers altogether. Operating a low-power Skyminer is as simple as plugging it into a home Internet router, which users are incentivized to do by earning cryptocurrency just for keeping nodes online. Skywire is designed to be hardware agnostic, meaning that people can buy Skyminers directly from Skycoin, or build their own using inexpensive materials available online. Running a Skyminer is an attractive investment for anyone who wishes to help build the Skywire infrastructure, but is not necessary in order to use the network.</p><p>“When Skyminers are attached to antennas, they can begin to link together into a wireless network that doesn’t require traditional Internet access in order to function, and can be accessed freely by any computer or device that can connect to a WiFi signal,” a spokesperson explained.</p><p>Users will not have to choose between two Internets; Skywire will allow access to the existing Internet for those who want the best of both worlds, though the ultimate in speed, privacy and security can only be found on Skywire.</p><p>The nature of Skywire’s decentralized and distributed infrastructure makes it considerably more robust than the current Internet, which has centralized access points through ISPs.</p><p>Skycoin will roll out a public mainnet for Skywire soon, which will mark the final phase in its launch. The first fully-functional large-scale mesh network running Skywire will debut in New York City before the end of the year, with other major cities around the world coming online in the near future as Skywire continues its ambitious worldwide roll-out.</p><p><strong>Interviews may be scheduled via email</strong>: <a href="mailto:drew@skycoin.com">drew@skycoin.com</a></p><p><strong>About Skycoin</strong></p><p>Skycoin is bringing people what they want: a truly decentralized network without any central authority. Founded in 2011 by early developers of Bitcoin and Ethereum, Skycoin quickly grew into an ecosystem of exciting and ambitious projects, including Skywire, the new decentralized Internet; CX, a revolutionary full-featured blockchain application programming language; and the cryptocurrency itself, Skycoin - simple to use, with virtually-free transactions that execute almost instantly. In 2020, Skycoin will release a superior “web-of-trust” blockchain consensus algorithm called Obelisk, which solves the problems inherent to “proof-of-work” and “proof-of-stake” protocols, both of which are slowing down and compromising the integrity of other major cryptocurrencies. For more background, please visit <a href="https://www.skycoin.com" rel="noopener noreferrer" target="_blank">https://www.skycoin.com</a></p><p><strong>Contact:</strong></p><p>Drew Macgibbon <br><a href="mailto:drew@skycoin.com">drew@skycoin.com</a></p><p><strong>SOURCE:</strong> Skycoin</p>',
      },
    },
    releases_october: {
      title: 'Skycoin Project Releases Hardware Development Kit (HDK) for New Cryptocurrency Wallet',
      description: 'Early Bitcoin and Ethereum Developers Set to Roll-Out "Skywire" - a New, Decentralized Internet from Skycoin',
      dates: 'August 23, 2019',
      content: {
        description: '<p>Skycoin is the first cryptocurrency to issue its own hardware wallet, along with a Hardware Development Kit to extend functionality</p><p>Shanghai, China / October 14th, 2019 / The Skycoin Project is pleased to announce the release of a Skywallet Hardware Development Kit (HDK) to anyone interested in extending the functionality of Skywallet, Skycoin’s sleek new hardware cryptocurrency wallet. The HDK is a developer-friendly version of the Skywallet, modified to facilitate programming and testing new code.</p><p>The Skywallet was made to support Skycoin (SKY) and Skycoin Coin Hours (SCH) out of the box, and a future firmware update will enable the Skywallet to hold additional major currencies, including Bitcoin, Ethereum, and more. But with thousands of cryptocurrency coins, tokens, and other assets available for trade, Skycoin wanted to ensure motivated developers had the opportunity to build support into Skywallet for their favourite cryptocurrency.</p><p>The support for additional cryptocurrencies may be accomplished using the HDK and then rolled out to Skywallet users in an optional firmware update, pending approval. The HDK may also be used to create applications that can run on Skywallet. For instance, if a developer wishes to use Skywallet as an authentication device, they could use the HDK to develop that functionality.</p><p>"We made Skywallet the most affordable hardware wallet on the market because we think crypto investors deserve the best security for their investment," said a spokesperson for the project. "We also know there are a lot of cryptocurrencies, and we wanted to give developers the chance to extend the power of Skywallet to their own favourite crypto coin or token."</p><p>The developer-friendly nature of Skywallet extends beyond the Hardware Development Kit to the firmware of the Skywallet itself, which is completely open-source. This means that the security of the Skywallet software may be verified by anyone who wishes to audit the code, because the complete codebase for the firmware is hosted in an open-source repository on <a href="https://github.com/skycoin/hardware-wallet" rel="noopener noreferrer" target="_blank">github</a>.</p><p>More exciting hardware projects from Skycoin, including Skywire antennas and the next generation of Skyminers, will be announced in the coming weeks and months.</p><p>The Skywallet Hardware Development Kit is available to order online at <a href="https://store.skycoin.com/" rel="noopener noreferrer" target="_blank">store.skycoin.com</a> beginning October 14, 2019.</p><p><strong>Media who wish to schedule interviews may reach out to:</strong> <br><strong>Drew MacGibbon</strong> <br><a href="mailto:drew@skycoin.com">drew@skycoin.com</a> <br>+15624529482</p><p> <br></p><hr><p> <br></p><p><strong>About Skycoin:</strong></p><p>Skycoin is bringing people what they want: a truly decentralized network without any central authority. Founded in 2011 by early developers of Bitcoin and Ethereum, Skycoin quickly grew into an ecosystem of exciting and ambitious projects, including <strong>Skywire</strong>, the new decentralized Internet; <strong>CX</strong>, a revolutionary fully-featured blockchain application programming language; and the cryptocurrency itself, <strong>Skycoin</strong> — simple to use, with virtually-free transactions that execute almost instantly.</p><p>In 2020, Skycoin will release a superior "web-of-trust" blockchain consensus algorithm called <strong>Obelisk</strong>, which solves the problems inherent to "proof-of-work" and "proof-of-stake" protocols, both of which are slowing down and compromising the integrity of other major cryptocurrencies.</p><p>For more background, please visit <a href="https://www.skycoin.com" rel="noopener noreferrer" target="_blank">https://www.skycoin.com</a></p>',
      },
    },
    releases_2019_10_17: {
      title: 'Secure and Private “New Internet” Skywire set to Launch in New York City',
      description: 'First Skywire NYC Meetup is a success',
      dates: 'October 17, 2019',
      content: {
        description: '<p><em>First Skywire NYC Meetup is a success</em></p><p><strong>New York City, New York / October 14th, 2019 /</strong> Skycoin held its first Skywire Mainnet Meetup in New York City on Thursday in anticipation of its forthcoming Skywire mesh network. The meeting took place at the NYC Blockchain Center, where Skycoin is a member, and was a great success. The meeting was also live-streamed via YouTube where dozens more watched it live, and several hundred tuned in to watch the final recording.</p><p>Skywire is the Skycoin Project’s new decentralized, private, and end-to-end encrypted internet. It is a mesh network comprised of small antennas attached to nodes called Skyminers. (Skyminers are powerful computers that provide the processing power, storage, and bandwidth for the network.)</p><p>The Skywire network in New York City is being built by members of the Skycoin community who believe in the principles of a free and open Internet, where privacy and security are foundational. Skywire puts the power is firmly in the hands of users, rather than Internet Service Providers, corporations, or advertisers. And unlike other attempts at creating community mesh nets, Skywire is incentivized. This means that Skycoin will pay node operators for their service to the network as a way to encourage growth and adoption of Skywire.</p><p>The ongoing rollout of the New York meshnet across Manhattan is a major milestone and proof-of-concept for the Skycoin Project, which has been working on the “new Internet” for nearly a decade.</p><p>Presenters at the meetup explained the technical details of the Skywire network to attendees, including multi-label packet switching (MPLS), public-key addressing, and software-defined networking, all of which make the Skywire network faster, safer, and more private than the current Internet. A number of antennas were shown as well, including long and short-range antennas. It is these antennas that will allow Skywire nodes to connect to one another across the city, and allow anyone within range to freely join the network.</p><p>The Skywire network will continue to be built over the coming months, growing stronger as more New Yorkers join the effort by deploying Skywire nodes of their own. The nodes themselves are easy to build using readily available parts, or may be purchased directly from skycoin.com.</p><p>Anyone interested in helping out should connect with the New York team via Telegram at t.me/SkycoinNewYork.</p><p><strong>Media who wish to schedule interviews may reach out to:</strong> <br><strong>Khalob Freeborn</strong> <br><a href="mailto:khalob@skycoin.comm">khalob@skycoin.com</a> <br>+14243542994</p><p> <br></p><hr><p> <br></p><p><strong>About Skycoin:</strong></p><p>Skycoin is bringing people what they want: a truly decentralized network without any central authority. Founded in 2011 by early developers of Bitcoin and Ethereum, Skycoin quickly grew into an ecosystem of exciting and ambitious projects, including <strong>Skywire</strong>, the new decentralized Internet; <strong>CX</strong>, a revolutionary fully-featured blockchain application programming language; and the cryptocurrency itself, <strong>Skycoin</strong> — simple to use, with virtually-free transactions that execute almost instantly.</p><p>In 2020, Skycoin will release a superior "web-of-trust" blockchain consensus algorithm called <strong>Obelisk</strong>, which solves the problems inherent to "proof-of-work" and "proof-of-stake" protocols, both of which are slowing down and compromising the integrity of other major cryptocurrencies.</p><p>For more background, please visit <a href="https://www.skycoin.com" rel="noopener noreferrer" target="_blank">https://www.skycoin.com</a></p>',
      },
    },
    releases_2019_11_26: {
      title: 'Skycoin Project Releases Affordable High-Security Hardware Wallet',
      description: 'Skycoin is the first cryptocurrency to issue its own hardware wallet.',
      dates: 'November 26, 2019',
      content: {
        description: '<p><em>Skycoin is the first cryptocurrency to issue its own hardware wallet.</em></p><p><em>Shanghai, China</em> — Skycoin is pleased to announce the immediate availability of <strong><em>Skywallet</em></strong>, a sleek and sophisticated cryptocurrency hardware wallet designed specifically with Skycoin in mind.</p><p>Skywallet was made to support Skycoin (SKY) and Skycoin Coin Hours (SCH) out of the box, and a future firmware update will enable the Skywallet to hold many different coins and tokens, including Bitcoin, Ethereum, and more. In addition, a Hardware Development Kit (HDK) is available to developers who wish to further extend the Skywallet’s functionality.</p><p>Skywallet is initially available in three different colors (black, white, and silver) for just $39.00 USD each. Despite the massive price drop relative to competition, no corners have been cut on ensuring that these devices are secure. In fact, the Skycoin team uncovered and resolved significant flaws in the firmware code of one of the most popular devices currently available.</p><p>“We wanted everyone to have an affordable option for securely protecting their Skycoin investment,” said a spokesperson for the project.</p><p>Unlike mobile or desktop software wallets, the seed phrase (or “private key”) that generates the Skycoin address on the Skywallet is never exposed to a computer or the Internet, and cannot be accessed or hijacked by an attacker.<strong>This means the Skywallet is completely private and secure</strong>, even if one’s personal computer or Internet connection is compromised.</p><p>The security of the Skywallet software may be verified by anyone who wishes to audit the code, because the complete codebase for the firmware is hosted in an open-source repository on <a href="https://github.com/skycoin/hardware-wallet" rel="noopener noreferrer" target="_blank">GitHub</a>.</p><p>The Skycoin team is uniquely qualified to produce Skywallets, as they have nearly a decade of experience building both hardware and software solutions to some of blockchain’s most intractable problems. Skycoin’s existing hardware products include approximately 10,000 Skyminer nodes deployed around the world, forming the telecommunications infrastructure of Skycoin’s new encrypted internet: Skywire.</p><p>More exciting hardware projects, including Skywire antennas and the next generation of Skyminers, will be announced in the coming weeks and months.</p><p>The Skywallet is available to order online at &nbsp; <a href="https://store.skycoin.com/" rel="noopener noreferrer" target="_blank">store.skycoin.com</a> beginning November 28, 2019.</p><p>Media who wish to schedule interviews may reach out to:&nbsp;</p><p>Tiffany</p><p> <a href="mailto:mktcn@skycoin.com">mktcn@skycoin.com</a></p><p>0085263533831</p><p> <br></p><hr><p> <br></p><p><strong>About Skycoin:</strong></p><p>Skycoin is bringing people what they want: a truly decentralized network without any central authority. Founded in 2011 by early developers of Bitcoin and Ethereum, Skycoin quickly grew into an ecosystem of exciting and ambitious projects, including <strong>Skywire</strong>, the new decentralized Internet; <strong>CX</strong>, a revolutionary fully-featured blockchain application programming language; and the cryptocurrency itself, <strong>Skycoin</strong> — simple to use, with virtually-free transactions that execute almost instantly.</p><p>In 2020, Skycoin will release a superior "web-of-trust" blockchain consensus algorithm called <strong>Obelisk</strong>, which solves the problems inherent to "proof-of-work" and "proof-of-stake" protocols, both of which are slowing down and compromising the integrity of other major cryptocurrencies.</p><p>For more background, please visit <a href="https://www.skycoin.com" rel="noopener noreferrer" target="_blank">https://www.skycoin.com</a></p>',
      },
    },
  },
  sky_wallet: {
    title: 'Skywallet - Skycoin`s New Hardware Wallet',
    description: 'Skywallet - New Hardware Wallet',
    about: {
      heading: 'Skywallet',
      subheading: 'Skycoin`s New Hardware Wallet',
      paragraph: 'When you store or access your cryptocurrency, you are your own bank, so the process should be simple and intuitive. Your hardware wallet is your bank vault and it should feel like a premium and secure device. We’ve spent months iterating over designs and incorporating user feedback in order to make Skywallet the best hardware wallet experience on the market.',
    },
    features: {
      heading: 'Getting started',
      recoveryseed: {
        title: 'Recovery seed',
        text:
          'The recovery seed is a backup for your entire device. If your device is lost or damaged, you can recover your wallets using the seed phrase. It is generated on your device and only shown once. It should go without saying that if somebody finds your seed, they can easily clone your device. Do not store the seed or communicate it digitally. Support will never ask for your seed.',
      },
      instructions: {
        title: 'Instructions',
        text:
          'Before connecting to your computer, please ensure that you have the latest version of the skycoin desktop wallet installed available at skycoin.com/downloads. If it is already installed, simply plug your device into your computer and follow the instructions on screen.',
      },
      treatment: {
        title: 'Treatment',
        text:
          'Do not expose the wallet to extreme temperatures or elements. It is not waterproof, heat or acid resistant.',
      },
      download: {
        title: 'Download',
        text:
          '<p>Download the Skywallet user manual here:</p><p> <a href="https://s3-ap-southeast-1.amazonaws.com/downloads.skycoin.com/skywallet/Skywallet-User_Manuals_Draft_1_c.pdf" rel="noopener noreferrer" target="_blank">User Manual</a></p><p>Download the Desktop Wallet and the Skywallet Daemon here:</p><p> <a href="/ko/downloads/">https://skycoin.com/downloads/</a></p>',
      },
    },
    roadmap: 'CX Roadmap',
  },
  skywallethdk: {
    title: 'Skywallet HDK',
    description: 'Skywallet HDK - Make your favourite token compatible with Skywallet',
    about: {
      heading: 'Skywallet HDK',
      subheading: 'Make your favourite token compatible with Skywallet',
      paragraph: '<p>The Skywallet HDK (Hardware Development Kit) is the developer-friendly version of the Skywallet hardware that is intended to make it easy to create applications, or integrate other cryptocurrencies and tokens into the Skywallet.</p><p>There are several key differences between the Skywallet and the Skywallet HDK that make the HDK easier to use for developers. The Skywallet HDK:</p><ul> <li>Does not have a case around the circuit board</li><li>Is physically bigger than the small, sleek consumer-facing Skywallet</li><li>Features larger buttons that are easier to work with</li><li>Has a 6-pin socket for ST programmer</li><li>Does not have a pre-flashed bootloader</li></ul><p>The primary use of the Skywallet HDK is to build capability into Skywallet to support cryptocurrencies beyond Skycoin and Skycoin Coin Hours. The HDK may also be used to create additional programs that may run on Skywallet. If a developer wishes to use Skywallet as an authentication device, for instance, they can use the HDK to develop that functionality.</p><p>All new programs and token compatibilities which are developed on the Skywallet HDK can be submitted to Skycoin for review. If approved, your update will be pushed out to all current Skywallet holders who can opt-in to the new functionality.</p><p>If you would like to extend the functionality and capability of Skywallet for all its users, grab a Skywallet HDK and get coding!</p>',
    },
    features: {
      heading: 'Getting started',
      instructions: {
        title: 'Instructions',
        text: '<p>Join the Telegram room <a href="https://t.me/SkycoinDevelopers" rel="noopener noreferrer" target="_blank">&commat;SkycoinDevelopers</a> or file an issue on Github if you want to get in touch with the development team.</p>',
      },
      treatment: {
        title: 'Treatment',
        text:
          'Do not expose the wallet to extreme temperatures or elements. It is not waterproof, heat or acid resistant.',
      },
      download: {
        title: 'Download',
        text:
          '<ul> <li> <a href="https://github.com/skycoin/hardware-wallet" rel="noreferrer nofollow" target="_blank">https://github.com/skycoin/hardware-wallet</a> </li><li> <a href="https://github.com/skycoin/hardware-wallet-daemon" rel="noreferrer nofollow" target="_blank">https://github.com/skycoin/hardware-wallet-daemon</a> </li><li> <a href="https://github.com/skycoin/hardware-wallet-go" rel="noreferrer nofollow" target="_blank">https://github.com/skycoin/hardware-wallet-go</a> </li></ul>',
      },
      documentation: {
        title: 'Documentation and codebase',
        text:
          '<ul> <li> <a href="https://github.com/skycoin/User-Manuals/tree/master/Skywallet" rel="noopener noreferrer" target="_blank">https://github.com/skycoin/User-Manuals/tree/master/Skywallet</a> </li><li> <a href="https://github.com/skycoin/hardware-wallet" rel="noopener noreferrer" target="_blank">https://github.com/skycoin/hardware-wallet</a> </li><li> <a href="https://github.com/skycoin/hardware-wallet-daemon" rel="noopener noreferrer" target="_blank">https://github.com/skycoin/hardware-wallet-daemon</a> </li><li> <a href="https://github.com/skycoin/hardware-wallet-go" rel="noopener noreferrer" target="_blank">https://github.com/skycoin/hardware-wallet-go</a> </li></ul>',
      },
    },
    gallery: {
      title: 'Gallery',
      description: 'Gallery',
      heading: 'Gallery',
      skywallethdk: {
        heading: 'Gallery',
      },
    },
  },
  cxchains: {
    title: 'CX Chains Overview',
  },
};



// WEBPACK FOOTER //
// ./src/locales/ko.js